import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["postalCode", "prefecture", "city", "address"]

  connect() {
    console.log("Address controller connected")
  }

  // 郵便番号から住所を自動入力
  async lookupAddress(event) {
    const postalCode = event.target.value.replace(/[^0-9]/g, '') // 数字のみ抽出
    
    if (postalCode.length !== 7) {
      return // 7桁でない場合は処理しない
    }

    try {
      // 郵便番号APIを呼び出し（zipcloud API使用）
      const response = await fetch(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${postalCode}`)
      const data = await response.json()

      if (data.status === 200 && data.results && data.results.length > 0) {
        const result = data.results[0]
        
        // 都道府県を設定
        if (this.hasPrefectureTarget) {
          this.prefectureTarget.value = result.address1
        }
        
        // 市区町村を設定
        if (this.hasCityTarget) {
          this.cityTarget.value = result.address2
        }
        
        // 町域を住所フィールドに設定
        if (this.hasAddressTarget && result.address3) {
          this.addressTarget.value = result.address3
        }

        // 成功を示すフィードバック
        this.showFeedback('success', '住所を自動入力しました')
      } else {
        this.showFeedback('error', '郵便番号が見つかりませんでした')
      }
    } catch (error) {
      console.error('Address lookup error:', error)
      this.showFeedback('error', '住所の取得に失敗しました')
    }
  }

  // 郵便番号のフォーマット
  formatPostalCode(event) {
    let value = event.target.value.replace(/[^0-9]/g, '') // 数字のみ
    
    if (value.length > 7) {
      value = value.substring(0, 7) // 7桁まで
    }
    
    // ハイフンを挿入
    if (value.length > 3) {
      value = value.substring(0, 3) + '-' + value.substring(3)
    }
    
    event.target.value = value
  }

  // フィードバック表示
  showFeedback(type, message) {
    // 既存のフィードバックを削除
    const existingFeedback = this.element.querySelector('.address-feedback')
    if (existingFeedback) {
      existingFeedback.remove()
    }

    // フィードバック要素を作成
    const feedback = document.createElement('div')
    feedback.className = 'address-feedback mt-2 p-2 rounded-md text-sm'
    
    if (type === 'success') {
      feedback.classList.add('bg-green-50', 'text-green-700', 'border', 'border-green-200')
    } else {
      feedback.classList.add('bg-red-50', 'text-red-700', 'border', 'border-red-200')
    }
    
    feedback.textContent = message
    
    // 郵便番号フィールドの後に挿入
    if (this.hasPostalCodeTarget) {
      this.postalCodeTarget.parentNode.appendChild(feedback)
    }

    // 3秒後に自動削除
    setTimeout(() => {
      if (feedback.parentNode) {
        feedback.remove()
      }
    }, 3000)
  }

  // 住所フィールドのクリア
  clearAddress() {
    if (this.hasPrefectureTarget) {
      this.prefectureTarget.value = ''
    }
    if (this.hasCityTarget) {
      this.cityTarget.value = ''
    }
    if (this.hasAddressTarget) {
      this.addressTarget.value = ''
    }
  }

  // 郵便番号の妥当性チェック
  validatePostalCode(event) {
    const postalCode = event.target.value.replace(/[^0-9]/g, '')
    const field = event.target
    
    // エラー表示をクリア
    this.clearFieldError(field)
    
    if (postalCode.length > 0 && postalCode.length !== 7) {
      this.showFieldError(field, '郵便番号は7桁で入力してください')
      return false
    }
    
    return true
  }

  // フィールドエラー表示
  showFieldError(field, message) {
    this.clearFieldError(field)
    
    const errorElement = document.createElement('p')
    errorElement.className = 'field-error mt-1 text-sm text-red-600'
    errorElement.textContent = message
    
    field.parentNode.appendChild(errorElement)
    field.classList.add('border-red-300', 'focus:border-red-500', 'focus:ring-red-500')
  }

  // フィールドエラークリア
  clearFieldError(field) {
    const errorElement = field.parentNode.querySelector('.field-error')
    if (errorElement) {
      errorElement.remove()
    }
    field.classList.remove('border-red-300', 'focus:border-red-500', 'focus:ring-red-500')
  }
}
